import React from 'react';
import styles from './EditorSection.module.scss';
import {Grid, Typography} from '@material-ui/core';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';
import CustomTextField from 'gui/components/customTextField';
import fill from 'fill-range';

export interface IEditorSectionProps {
  title?: string;
  titleClassName?: string;
  children?: any;
  loading?: boolean;
}

const LoadingSection = () => <Grid container spacing={2} style={{marginTop: 5, marginBottom: 40}}>
  {fill(0, 7).map(index => <Grid item key={index} sm={6}>
    <CustomTextField
      loading={true}
    />
  </Grid>)}
</Grid>;

const EditorSection = (props: IEditorSectionProps) => {
  return (
    <>
      <Grid item xs={12} className={styles.titleContainer}>
        <Typography variant="h6" component="h6" className={`${styles.topTitle} ${props.titleClassName}`}>
          {props.loading ? <SkeletonPlaceHolder width={125} height={16}/> : props.title}
        </Typography>
      </Grid>
      {props.loading ? <LoadingSection/> : props.children}
    </>
  );
};

EditorSection.defaultProps = {
  title: '',
  children: null,
  loading: false,
  titleClassName: '',
};

export default React.memo(EditorSection);
